<template lang="pug">
  .DigitalCity
    top-informations(title="数字城市" subtitle="让城市迈入数智时代"
      text="Let the city enter the era of digital economy")
    project-design(text="提供“区块链+智能大脑”的整体解决方案，打造安全可靠、高效智能、普惠便民、生态融合的数字城市。")
    framework(:framework="framework")
    core-tech(:core-tech="techs")
    scene(:scenes="['商圈', '旅游', '医疗','交通']")
</template>

<script>
  // import framework from '@/assets/images/数字城市实现架构.png'
  const framework = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-%E6%95%B0%E5%AD%97%E5%9F%8E%E5%B8%82-%E6%9E%B6%E6%9E%84%E5%9B%BE.png';
  import img1 from '@/assets/images/安全可信.png'
  import img2 from '@/assets/images/打破数据孤岛.png'
  import img3 from '@/assets/images/开放生态.png'
  import img4 from '@/assets/images/监管创新.png'
  
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import CoreTech from "@/views/Solution/components/coreTech/coreTech";
  import Scene from "@/views/Solution/components/Scene/Scene";
  
  export default {
    name: "DigitalCity",
    components: {Scene, CoreTech, Framework, ProjectDesign, TopInformations},
    props: {},
    data() {
      return {
        framework,
        techs: [
          {img: img1, title: '安全可信', text: '底层安全：区块链安全可信\n隐私保护：有限数据共享，隐私数据边缘存储\n服务安全：全城上链接受可信监管'},
          {img: img2, title: '打破数据孤岛', text: '架构创新：区块链+边缘计算+AI+大数据融合架构\n数据确权：利用区块链实现数据归属、交易监管、价值分配\n积分激励：建设可信积分激励体系，促进数据共享'},
          {img: img3, title: '开放生态', text: '服务开放：开放标准服务，共建行业生态\n架构开放：开源区块链的应用开发框架\n国际化：建设国标标准，链接世界'},
          {img: img4, title: '监管创新', text: '监管：透明监管、穿透式监管、自动化实时监管\n创新：数据服务先行，审批后置'},
        ],
      };
    },
    watch: {},
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
  };
</script>

<style scoped lang="stylus">
  .DigitalCity {
  
  }
</style>
